<template>
  <RfSimpleCard title="Sales Admin" class="p-10">
    <RfButtonNew size="large" class="mt-5" @click="adminsStore.createSampleData(model.id)">
      <RfAddIcon class="h-6! w-6!" />
      Generate Sample Data
    </RfButtonNew>
  </RfSimpleCard>
</template>

<script setup>
import RfSimpleCard from "@/components/RfSimpleCard.vue";
import { useAdminsStore } from "@/pinia/adminStore";
import RfButtonNew from "@/components/buttons/RfButtonNew.vue";
import RfAddIcon from "../icons/RfAddIcon.vue";

defineProps(["model"]);
const adminsStore = useAdminsStore();
</script>
